// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Enter not into judgement with your servant,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for in your sight shall no one living be justified.<br> </p> </div></div>";
// Exports
module.exports = code;